import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FloatingSubmenuCoordinatorService } from '../../services/floating-submenu-coordinator.service';
import { SigninService } from 'src/app/signin/signin.service';
import { DataManagementService } from 'src/app/pages/data-management/data-management.service';

@Component({
  selector: 'app-historical-submenu',
  templateUrl: './historical-submenu.component.html',
  styleUrls: ['./historical-submenu.component.scss'],
})
export class HistoricalSubmenuComponent implements OnDestroy {
  readonly submenuId = 'historical';

  showSubmenu = false;
  submenuTimeout: any;
  submenuLeft = 0;

  /** Ignore backdrop taps from the same gesture that opened the menu (mobile ghost click). */
  private ignoreBackdropCloseUntil = 0;

  private coordinatorSubscription: Subscription;

  constructor(
    private submenuCoordinator: FloatingSubmenuCoordinatorService,
    public signinService: SigninService,
    public dataManagementService: DataManagementService,
  ) {
    this.coordinatorSubscription = this.submenuCoordinator.watchActiveSubmenu().subscribe(activeId => {
      if (activeId !== this.submenuId) {
        this.hideFloatingSubmenu(true, false);
      }
    });
  }

  ngOnDestroy(): void {
    this.coordinatorSubscription?.unsubscribe();
  }

  showFloatingSubmenu(event?: MouseEvent) {
    if (event?.currentTarget) {
      const target = event.currentTarget as HTMLElement;
      const rect = target.getBoundingClientRect();
      this.submenuLeft = rect.left + rect.width / 2;
    }
    clearTimeout(this.submenuTimeout);
    this.submenuCoordinator.open(this.submenuId);
    this.showSubmenu = true;
    // Prevent the opening tap from immediately closing via the backdrop.
    this.ignoreBackdropCloseUntil = Date.now() + 450;
  }

  toggleFloatingSubmenu(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    if (this.showSubmenu) {
      this.hideFloatingSubmenu(true);
    } else {
      this.showFloatingSubmenu(event as MouseEvent);
    }
  }

  toggleSubmenu(event?: Event) {
    this.toggleFloatingSubmenu(event);
  }

  onBackdropClick(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    if (Date.now() < this.ignoreBackdropCloseUntil) {
      return;
    }
    this.hideFloatingSubmenu(true);
  }

  hideFloatingSubmenu(immediate = false, notifyCoordinator = true) {
    clearTimeout(this.submenuTimeout);
    if (immediate) {
      this.showSubmenu = false;
      if (notifyCoordinator) {
        this.submenuCoordinator.closeAll();
      }
      return;
    }
    this.submenuTimeout = setTimeout(() => {
      this.showSubmenu = false;
      if (notifyCoordinator) {
        this.submenuCoordinator.closeAll();
      }
    }, 300);
  }

  canShowVideoPlayback(): boolean {
    return this.signinService.hasVehicleCameraOption(this.dataManagementService.selectedVehicule);
  }
}
